// Vite provides BASE_URL automatically from vite.config.ts base option
// BASE_URL will be "/auth/" in this case
const basePath = import.meta.env.BASE_URL || '/';

const Images = {
  CHECK_YOUR_EMAIL: `${basePath}check-your-email.png`,
  SUCCESS: `${basePath}success.png`,
  FAILED: `${basePath}failed.png`,
  ACCOUNT_LOCKED: `${basePath}account-locked.jpg`,
  LINK_EXPIRED: `${basePath}link-expired.png`,
  INVITE: `${basePath}invite.png`,
  LOGO: `${basePath}moneylingo-logo.png`,
};

export default Images;
